import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect, useState } from "react";
import HoverImage from "react-hover-image/build";
import { Button } from "reactstrap";
import { cellRendererCheck, dateFormate } from "utils/columns";
import Maping from "assets/icon/MapIcon.svg";
import MapHover from "assets/icon/MapIconHover.svg";
import UnMapped from "assets/icon/UnMapped.svg";
import Loader from "components/Loader";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import { cloneDeep } from "lodash";
import { ModuleAccess } from "utils/moduleaccess";
// import UnMappedHover from "assets/icon/UnMappedHover.svg"
import Smallspinlogo from "assets/images/upload.gif";

const UmMappedChargeCodeTable = (props) => {
  const {
    unmapedChargeCount,
    manvalConfigedit,
    manvalConfig,
    manvalPharmacy,
    onSearchColumnFilters = () => "",
    data,
    totalSize,
    unmapedNdcCount,
    filters,
    orgId,
    onPageChange,
    searchTerms,
    search,
    onclick,
    refetch,
    load,
    toggleSider,
    collapseSider,
    setNdcMapingFlag,
    ndcmapingflag,
    selectedRow,
    setselectedRow,
    resetFilterFlag,
    SetResetFilterFlag,
    Chargecodeflag,
    setChargeCodeflag,
    unMappedChargeTableData,
    setUnMappedChargeTableData,
    unmappedchargesearch,
    unmappedChargeTotalrecords,
    loading,
    setLoading,
    mapingHistoryData,
    setMapingHistoryData,

    utilizationData,
    setUtilizationData,
    setChargeCodeDetails,
    setUtilizationDataRecords,
    utilizationDataRecords,
    unMappedChargecolumnFilters,
    purchaseHistoryinstialValues,
    selectedutilizationData,
    setSelectedUtilizationData,
  } = props;

  const API = useAxios();

useEffect(()=>{
  setChargeCodeflag(false)
},[orgId])



  const [disablehidebtn, setDisablehidebtn] = useState(false);
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 117,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "ChargeCode1",
      text: "Charge Code",
      sort: true,
      width: 161,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeCode),
    },
    {
      dataField: "chargeDescription",
      text: "Charge Description",
      sort: true,
      width: 268,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeDescription),
    },
    {
      dataField: "unmappedCharges",
      text: "Pending Utilization Count",
      sort: true,
      width: 251,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.unmappedCharges),
    },
    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      width: 152,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 151,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 200,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },
  ];

  const togglemapingview = (rowData) => {
    setChargeCodeDetails(rowData);
    setChargeCodeflag(true);
    handleMap(rowData);
  };
  const renderMapping = (rowData) => {
    if (hasPermission("HI"))
      if (rowData.isEdit != true)
        return (
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => togglemapingview(rowData)}
            hidden={rowData.hiddenReprocessFlag == "H"}

            title="Map"
          >
            <HoverImage key="Maping" src={Maping} hoverSrc={MapHover} alt="" />
          </Button>
        );
  };
  const handlehide = async (rowData, status) => {
    debugger;
    let accid = rowData?.accumulatorID;
    let chargeId = rowData?.chargeID;
    setDisablehidebtn(true);
    setLoading(true);
    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/Crosswalk/HiddenAndUnHiddenchargeCode/${accid}/${chargeId}/${status}`,
        {
          hasDefaultURL: true,
        }
      );
      if (data.error == true) {
        toast.error(data.message, {
          onClose: () => setDisablehidebtn(false),
        });
        setLoading(false);
      }
      if (data.error == false) {
        refetch(true);
        toast.success(data.message, {
          onClose: () => setDisablehidebtn(false),
        });
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const handleMap = async (rowData) => {
    debugger;
    fetchmapingHistory(rowData);
    fetchutilizationHistory(rowData, purchaseHistoryinstialValues);
  };
  const hasPermission = (code) => {
    return ModuleAccess("CRW", code);
  };
  const fetchmapingHistory = async (rowData) => {
    setSelectedUtilizationData(rowData)
    let chargeId = rowData?.chargeID;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/ChargeCodeMappingHistory/${chargeId}`,
        unmappedchargesearch,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setMapingHistoryData(data.items);
        //setLoading(false);
      }
      else {
        setMapingHistoryData([]);
      }
    } catch {
      // setLoading(false);
    }
  };
  const fetchutilizationHistory = async (rowData, purchaseHistoryinstialValues) => {
    let chargeId = rowData?.chargeID;
    purchaseHistoryinstialValues.currentPage = 1;
    purchaseHistoryinstialValues.pageSize = 10;
    
    //setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/ChargeCodeUtilizationHistory/${chargeId}`,
        purchaseHistoryinstialValues,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setUtilizationData(data.items);
        setUtilizationDataRecords(data.totalRecords);
        setLoading(false);
      } else {
        setLoading(false);
        setUtilizationData([]);
        setUtilizationDataRecords(0);
      }
    } catch {
      setLoading(false);
    }
  };
  const renderspin = (rowData) => {

    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        // onClick={()=>togglemapingview(rowData)}
        title="Hidden Reprocess In progress"
        hidden={rowData.hiddenReprocessFlag !== "H"}
      >
        <HoverImage
          key="Maping"
          src={Smallspinlogo}
          hoverSrc={Smallspinlogo}
          alt=""
        />
      </Button>
    );
  };
  const renderHide = (rowData) => {
    if (hasPermission("HI"))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => handlehide(rowData, "hide")}
          hidden={rowData.hiddenReprocessFlag == "H" || rowData.reProcessedFlag == "Y"}

          title="Hide"
          disabled={disablehidebtn}
        >
          <HoverImage key="Maping" src={UnMapped} hoverSrc={UnMapped} alt="" />
        </Button>
      );
  };
  const cellRenderEdit = (rowData) => {
    return (
      <div className="d-flex align-items-center">
        {renderMapping(rowData)}
        {renderHide(rowData)}
        {renderspin(rowData)}
      </div>
    );
  };
  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleFilterCancel = () => {
    refetch(true);
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
    }
  };
  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(unmappedchargesearch);
    //filterObj.ActiveButton = ActiveButton
    if (unMappedChargecolumnFilters && unMappedChargecolumnFilters.length > 0) {
      filterObj.filters = [
        ...filterObj.filters,
        ...unMappedChargecolumnFilters,
      ];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID;
    payload.gridCode = "unmappedchargecodes";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };
  return (
    <div>
      {/* {loading && <Loader opacity={0.01} />} */}

      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          unMappedChargeTableData?.length > 0 ? "fixed-height" : "default"
        }
      >
        <ReactStrapTable
          id="unmappedchargecode"
          height={550}
          fixedColumn
          width={1200}
          hasPagination
          // reset={reset}
          data={unMappedChargeTableData}
          columns={mainCol}
          onExport={handleExport}
          filters={unmappedchargesearch}
          totalRecords={unmappedChargeTotalrecords}
          pageSize={unmappedchargesearch.pageSize}
          currentPage={unmappedchargesearch.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          toggleSider={toggleSider}
          collapseSider={collapseSider}
          showtoggle={true}
          resetFilterFlag={resetFilterFlag}
          SetResetFilterFlag={SetResetFilterFlag}
        // hasExportPermission={hasExportPermission}
        />
      </div>
    </div>
  );
};

export default UmMappedChargeCodeTable;
